"use client"

import Pusher from "pusher-js"
import { env } from "@/configs/env"

// Debug: Check if environment variables are available (you can remove this after testing)
console.log(
  "Pusher Key:",
  env.NEXT_PUBLIC_PUSHER_KEY ? "Available" + env.NEXT_PUBLIC_PUSHER_KEY : "Missing"
)
console.log(
  "Pusher Cluster:",
  env.NEXT_PUBLIC_PUSHER_CLUSTER ? "Available" + env.NEXT_PUBLIC_PUSHER_CLUSTER : "Missing"
)
console.log(
  "Pusher Base URL:",
  env.NEXT_PUBLIC_BASE_URL ? "Available" + env.NEXT_PUBLIC_BASE_URL : "Missing"
)

// Pusher.logToConsole = true;
// Initialize and export the Pusher client
const pusherClient = (organization: string) => {
  return new Pusher(env.NEXT_PUBLIC_PUSHER_KEY as string, {
    cluster: env.NEXT_PUBLIC_PUSHER_CLUSTER as string,
    authEndpoint: `${env.NEXT_PUBLIC_BASE_URL}/api/auth/pusher?organization=${organization}`,
    userAuthentication: {
      endpoint: `${env.NEXT_PUBLIC_BASE_URL}/api/auth/pusher?organization=${organization}`,
      transport: "ajax",
    },
  })
}

export default pusherClient
